import { removeLastSlash, removeLinkParams } from './link';
var baseTwitchPath = 'twitch.tv/';
var baseEmbeddedPath = 'https://player.twitch.tv/?';
var createEmbeddedLink = function (link) {
    var _a;
    var paths = (_a = removeLastSlash(removeLinkParams(link))) === null || _a === void 0 ? void 0 : _a.split(baseTwitchPath)[1].split('/');
    var finalPath = (paths === null || paths === void 0 ? void 0 : paths.length) === 1
        ? "channel=" + paths[0]
        : (paths === null || paths === void 0 ? void 0 : paths.length) === 3
            ? "video=" + paths[2]
            : undefined;
    return finalPath
        ? "" + baseEmbeddedPath + finalPath + "&parent=" + window.location.hostname + "&autoplay=false"
        : undefined;
};
export var twitch = {
    category: 'VIDEO',
    isSatisfied: function (link) { return link.includes(baseTwitchPath); },
    getPlayerExecutionProps: function (link) { return ({
        link: createEmbeddedLink(link),
        allowProps: 'encrypted-media',
    }); },
};
